export default __webpack_public_path__ + "static/media/favorites_icon_no_fill.47799786.svg";